var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Icon, Text } from 'shared/components';
import { useMemberForAppointment } from 'pages/Note/hooks';
import { Info } from 'src/shared/assets/icons';
import { useMemberMedications } from 'shared/features/erx';
import { useFlagEnabled } from 'flagging/hooks';
import { useNoteSchemaContext } from '../../note';
import { noteType } from 'src/constants/ehrNoteEnums';
export var MemberMedicationsInfoBox = function () {
    var _a, _b;
    var type = useNoteSchemaContext().noteType;
    var isMedManagmentNote = type === noteType.adultMedManagementFollowUp ||
        type === noteType.adultMedManagementIntake ||
        type === noteType.minorMedManagementIntake ||
        type === noteType.minorMedManagementFollowUp;
    var erxEnabled = useFlagEnabled('ENABLE_MEDICATIONS_TAB') && isMedManagmentNote;
    var member = useMemberForAppointment().data;
    var medications = useMemberMedications((_b = (_a = member === null || member === void 0 ? void 0 : member.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', !erxEnabled).data;
    if (!(medications === null || medications === void 0 ? void 0 : medications.length) || !erxEnabled)
        return _jsx(_Fragment, {});
    return (_jsx(Box, __assign({ backgroundColor: "blue.100", color: "blue.500", padding: 4, rounded: "2xl", mb: 3 }, { children: _jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(Icon, { as: Info, mr: 3, boxSize: 4 }), _jsxs(Flex, __assign({ flexDir: "column" }, { children: [_jsxs(Text, __assign({ size: "body2" }, { children: ["This client has ", medications.length, " active psychiatric medication", medications.length === 1 ? '' : 's', ". Go to their Medications tab to see details."] })), _jsx(Box, __assign({ marginLeft: 4, marginTop: 3 }, { children: _jsx("ul", { children: medications.map(function (_a) {
                                    var prescriptionId = _a.prescriptionId, name = _a.name;
                                    return (_jsx("li", { children: _jsx(Text, __assign({ size: "body2" }, { children: name })) }, prescriptionId));
                                }) }) }))] }))] })) })));
};
